<template>
  <div>
    <div v-if="!embed" class="row">
      <div class="col-lg-12 col-xxl-12">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body pb-10 pt-10 page-container">
            <div class="d-flex align-items-center mb-5">
              <b-button variant="light" class="mr-3" @click="goBack">
                {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.BTN_BACK") }}
              </b-button>
              <h4 class="mb-0">
                {{
                  $t(
                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_PROFILE_TITLE"
                  )
                }}
              </h4>
            </div>
            <campaign-member-profile-body
              :loading="loading"
              :error="error"
              :payload="payload"
            />
          </div>
        </div>
      </div>
    </div>
    <campaign-member-profile-body
      v-else
      :loading="loading"
      :error="error"
      :payload="payload"
    />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CampaignMemberProfileBody from "./CampaignMemberProfileBody.vue";

export default {
  name: "CampaignMemberProfile",
  components: {
    CampaignMemberProfileBody
  },
  props: {
    embed: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: [String, Number],
      default: null
    },
    customerCampaignId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      payload: null
    };
  },
  computed: {
    resolvedCampaignId() {
      if (this.embed && this.campaignId != null && this.campaignId !== "") {
        return this.campaignId;
      }
      return this.$route.params.campaignId;
    },
    resolvedCustomerCampaignId() {
      if (
        this.embed &&
        this.customerCampaignId != null &&
        this.customerCampaignId !== ""
      ) {
        return this.customerCampaignId;
      }
      return this.$route.params.customerCampaignId;
    }
  },
  async mounted() {
    if (!this.embed) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
          route: "/campaign"
        },
        {
          title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`,
          route: `/campaign/form/campaign_receipt/${this.resolvedCampaignId}`
        },
        {
          title: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_PROFILE_TITLE"
          )}`
        }
      ]);
    }
    await this.fetchProfile();
  },
  methods: {
    async fetchProfile() {
      this.loading = true;
      this.error = false;
      try {
        ApiService.setHeader();
        const { data } = await ApiService.getParams(
          `campaign/${this.resolvedCampaignId}/members/${this.resolvedCustomerCampaignId}`,
          {}
        );
        if (data.status === "success" && data.data) {
          this.payload = data.data;
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push(
        `/campaign/form/campaign_receipt/${this.resolvedCampaignId}`
      );
    }
  }
};
</script>
